module.exports = require("@babel/runtime/helpers/readOnlyError");